import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './components/App';
import * as serviceWorker from './serviceWorker';
import './firestore';
import { getUser } from './firestore/user';

// Check if our user still exists first
const getCurrentUserId = new Promise((resolve) => {
    const currentUserId = localStorage.getItem('currentUserId') || '';
    if (currentUserId) {
        // Fetch user
        return getUser(currentUserId).then((currentUser) => {
            if (currentUser) {
                resolve(currentUser.id);
            }
            resolve();
        });
    } else {
        resolve();
    }
});

getCurrentUserId.then((existingUserId) => {
    ReactDOM.render(
        <React.StrictMode>
            <App existingUserId={existingUserId} />
        </React.StrictMode>,
        document.getElementById('root'),
    );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
